class TextQuestionStrategy {
    constructor(playScreenController, result) {
        this.playScreenController = playScreenController;
        this.result = result;
        this.mediaContainer = null;
        this.questionContainer = null;
    };

    draw() {

        this.mediaContainer = $('#mediaContainer');
        this.questionContainer = $('#questionContainer');
        this.mediaContainer.slideDown();
        this.mediaContainer.css('text-align', 'center');
        this.preloader = this.playScreenController.createPreloader(customIcons["QUESTION_MULTIMEDIA_ONLY_TEXT"]).appendTo(this.mediaContainer);

        if (!this.result.own_poll) {
            this.questionContainer.css('background-color', '#' + this.playScreenController.currentQuestion.category.color);
        }
        this.questionContainer.css('min-height', 'calc(100% - 185px)');
        const mainContainer = $('#mainContainer');
        mainContainer.css('overflow', 'auto');
        this.questionContainer = null;
        this.preload();
        $('body').addClass('stop-scrolling');
    };

    preload() {

            if (!this.result.own_poll) {
            $(".question-color-wrapper").css("background-color", hex2rgba(this.playScreenController.currentQuestion.category.color, 0.75));
        }

        $(".question-color-wrapper").show();
        this._preloadTimeout = setTimeout(this.startTime.bind(this), this.result.poll_end_resume ? 750 : 1500);
    };

    startTime() {
        this.hideImage();
        $(".question-color-wrapper").hide();
        this.showAnswerButtonTexts();
        if (!this.result.own_poll) {
            this.playScreenController.startTimer(this.result);
        } else {
            this.playScreenController.startTimerPoll(this.result);
        }
    };

    hideImage() {
        if(this.preloader) {
            this.preloader.hide();
        }
        this.mediaContainer.slideUp();
        $('body').removeClass('stop-scrolling');
    };

    hideAnswerButtonTexts() {
        $('.answerBtn').each(function(i, elem) {
            elem = $(elem);
            elem.text(' ');
        });
    }

    showAnswerButtonTexts() {
        $('.answerBtn').each(function(i, elem) {
            elem = $(elem);
            elem.text(elem.attr('data-answer'));
        });
    }

    cancel() {
        clearTimeout(this._preloadTimeout);
    }

}